"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _DragDropContext = _interopRequireDefault(require("./DragDropContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// dragDropHandlers: A key/value pair.
// One key for each category. The value is an object of the different drag-drop handlers for that category
// hoverStyles: Styles to apply to the control being hovered over
var DragDropProvider = function DragDropProvider(_ref) {
  var dragDropHandlers = _ref.dragDropHandlers,
      hoverStyles = _ref.hoverStyles,
      children = _ref.children;

  var beginMoveControl = function beginMoveControl(category) {
    var _dragDropHandlers$cat;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_dragDropHandlers$cat = dragDropHandlers[category]).beginMoveControl.apply(_dragDropHandlers$cat, args);
  };

  var moveControl = function moveControl(category) {
    var _dragDropHandlers$cat2;

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return (_dragDropHandlers$cat2 = dragDropHandlers[category]).moveControl.apply(_dragDropHandlers$cat2, args);
  };

  var dropControl = function dropControl(category) {
    var _dragDropHandlers$cat3;

    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return (_dragDropHandlers$cat3 = dragDropHandlers[category]).dropControl.apply(_dragDropHandlers$cat3, args);
  };

  var undropControl = function undropControl(category) {
    var _dragDropHandlers$cat4;

    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    return (_dragDropHandlers$cat4 = dragDropHandlers[category]).undropControl.apply(_dragDropHandlers$cat4, args);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactDnd.DndProvider, {
    backend: _reactDndHtml5Backend.HTML5Backend
  }, /*#__PURE__*/_react["default"].createElement(_DragDropContext["default"].Provider, {
    value: {
      hoverStyles: hoverStyles,
      beginMoveControl: beginMoveControl,
      moveControl: moveControl,
      dropControl: dropControl,
      undropControl: undropControl
    }
  }, children));
};

DragDropProvider.propTypes = {
  dragDropHandlers: _propTypes["default"].object.isRequired,
  hoverStyles: _propTypes["default"].object,
  children: _propTypes["default"].node
};
var _default = DragDropProvider;
exports["default"] = _default;